import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { IBranchExchangeModel } from 'src/app/logic/branch/models/branch-exchange.model';
import { IBranchModel } from 'src/app/logic/branch/models/branch.model';
import { BranchExchangeUsecase } from 'src/app/logic/branch/usecases/branch-exchange.usercase';
import { IExchangeModel } from 'src/app/logic/exchanges/model/exchange.model';
import { ModalComponent } from '../modal/modal.component';
import { ExchangeService } from 'src/app/services/exchange.service';
@Component({
  selector: 'app-promo-modal',
  templateUrl: './promo-modal.component.html',
  styleUrls: ['./promo-modal.component.scss'],
})
export class PromocionModalComponent implements OnInit {
  public sucursal: IBranchModel | undefined;
  public mxnExchange: IExchangeModel | undefined;
  public tablaPrecios: any = [];
  public sucursalId: number = 0;
  public divisas: any;

  constructor(
    private readonly _bottomSheetRef: MatBottomSheetRef<PromocionModalComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public promocion: any,
    private readonly dialog: MatDialog,
    private readonly exchangeService: ExchangeService
  ) {}

  ngOnInit(): void {
    this.exchangeService
      .getBranchExchangeRates(this.promocion.branch.id)
      .subscribe(({exchange}: IBranchExchangeModel) => {
        this.mxnExchange = (exchange as any[]).find(
          (value: any) => value.currency?.code === 'MXN'
        );
        this.tablaPrecios = (exchange as any[]).filter(
          (value: any) => value.currency?.code !== 'MXN'
        );
        this.divisas = exchange;
      });
  }

  getBranchPhone(): string {
    return this.promocion.branch.contacts?.find(
      (contact: any) => contact.type == 'PHONE'
    )?.value || '';
  }

  getBranchWhatsapp(): string {
    return this.promocion.branch.contacts?.find(
      (contact: any) => contact.type == 'WHATSAPP'
    )?.value || '';
  }
  
  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }

  reservar() {
    this.onNoClick();
    const isMobile = window.innerWidth < 768;
    const config: MatDialogConfig = {
      data: {
        sucursal: this.promocion.branch,
        precios: structuredClone(this.divisas),
        tienes: this.mxnExchange,
        quieres: this.promocion.exchangeRate,
      },
      closeOnNavigation: true,
      disableClose: true,
      panelClass: 'custom-modalbox',
      position: { bottom: '0', right: '0' },
      maxHeight: isMobile ? '85vh' : '70vh',
    };

    this.dialog
      .open(ModalComponent, config)
      .afterClosed()
      .subscribe((result) => {});
  }
}
